import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://603f93513fed473814a01b8141681fc5@o4510036965982208.ingest.de.sentry.io/4510036969979984",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
